import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://3d337139bd8639ef3b7f47887d61ceb2@o4505123926573056.ingest.us.sentry.io/4511425414430720',
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

import { PropsWithChildren, StrictMode, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/app';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './styles/theme';
import FirebaseProvider from './components/provider/firebase';
import { FirebaseOptions } from '@firebase/app';
import { useLocation } from 'react-router-dom';

const AppProvider = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBBWYN8J9qBF5U87eo-DUxemD6hhoV7KpY',
  authDomain: 'datium-381908.firebaseapp.com',
  projectId: 'datium-381908',
  storageBucket: 'datium-381908.firebasestorage.app',
  messagingSenderId: '350978252083',
  appId: '1:350978252083:web:d7f5a0eec8f053c7bbb246',
  measurementId: 'G-9R77PB4YGW',
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <AppProvider>
      <BrowserRouter>
        <FirebaseProvider firebaseConfig={firebaseConfig}>
          <App />
        </FirebaseProvider>
      </BrowserRouter>
    </AppProvider>
  </StrictMode>,
);
